import React from 'react';
import './Clientes-Modal.css';
import VideoP from './assets/Seminario/Seminario.mp4';
import Video from './assets/Seminario/Video.mp4';


const Seminario = () => {
  return (
    <div className="container">
         <h2>✅ Proyecto: Seminario Menor Santo Tomás de Aquino🌞✨</h2>
      
      <video controls>
        <source src={Video} type="video/mp4" />
        Tu navegador no soporta la reproducción de video.
      </video>

     <p>
        

<span className="highlight"> Energía que ilumina el futuro: formación, sostenibilidad y ahorro al servicio de la educación.</span>

<br /><br />En el Seminario Menor Santo Tomás de Aquino,<span className="highlight"> una institución educativa dirigida por la Iglesia que forma niños y jóvenes desde primaria hasta grado 11 en la ciudad de Pamplona, </span>instalamos un sistema solar fotovoltaico conectado a la red con una capacidad de 14.63 kWp, compuesto por 22 paneles solares de alta eficiencia y un inversor multicanal de 15 kW.
<br /><br />Esta tecnología permite optimizar el rendimiento energético del colegio, garantizando un suministro estable y seguro para sus actividades académicas y administrativas.<br/><br/>

Los objetivos de este proyecto fueron:<br/>

<br/>✔ Reducir los costos asociados al consumo eléctrico del colegio.
<br/>✔ Implementar una solución sostenible, coherente con los valores y el cuidado del medio ambiente.
<br/>✔ Garantizar energía continua para iluminación, equipos pedagógicos y uso institucional.<br/><br/>

Hoy, el Seminario Menor Santo Tomás de Aquino genera su propia energía limpia, disminuyendo mensualmente los costos por consumo eléctrico y permitiendo que esos recursos puedan ser destinados a fortalecer la formación de los estudiantes.

<br/><br/>Con esta instalación, el colegio no solo educa desde la palabra, sino también desde el ejemplo, convirtiéndose en un referente de responsabilidad ambiental y gestión eficiente dentro del sector educativo de la región.

<span className="highlight"><br/><br/>Este proyecto cuenta con el acompañamiento de IPSUM Ingeniería e Innovación, ofreciendo:</span><br/>

<br/>🔧 Soporte técnico y mantenimiento preventivo.
<br/>🔧 Monitoreo del sistema para garantizar máxima eficiencia energética.
<br/>🔧 Instalación estructural segura y diseñada para prolongar la vida útil del sistema además de facilitar el proceso de mantenimiento.
<br/>🔧 Capacitación al usuario en el manejo de la aplicación de monitoreo.
<br/>🔧 Acompañamiento presencial de nuestros ingenieros durante y después de la instalación.

<span className="highlight"> <br/><br/>Una decisión inteligente que une sostenibilidad, ahorro y un propósito educativo con visión de futuro.</span>
      </p> 

      <div className="video-responsive">
        <iframe
          src="https://www.youtube.com/embed/bxTfvk7LSgk"
          title="Testimmonio Palacio Arzobispal"
          frameBorder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
        ></iframe>
      </div>

      <video controls>
        <source src={VideoP} type="video/mp4" />
        Tu navegador no soporta la reproducción de video.
      </video>
           

    </div>
  );
};

export default Seminario;
